module.exports = __webpack_public_path__ + "img/Villa_Borna_3.0823220a.jpg";